import { createAsyncThunk } from "@reduxjs/toolkit";
import { 
  getArticleAction,
  getTableColumnNames,
  deleteArticleAction as removeArticleAction,
} from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";
import { t } from "i18next";


// Fetch Article Action Report
export const fetchArticleAction = createAsyncThunk(
  "articleAction/fetch",
  async (articleAction, { rejectWithValue }) => {
    try {
      const response = await getArticleAction(articleAction);
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error fetching human categories");
    }
  }
);

// Fetch Article Action Report Table Column Names
export const fetchArticleActionTableColumnNames = createAsyncThunk(
  "articleAction/fetchArticleActionTableColumnNames",
  async (articleAction, thunkAPI) => {
    try {
      const response = await getTableColumnNames(articleAction);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);

export const deleteArticleAction = createAsyncThunk(
  "articleAction/delete",
  async (articleAction, { rejectWithValue }) => {
    try {
      const response = await removeArticleAction(articleAction);
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Something went wrong");
    }
  }
);